import { Grid } from '@mui/material';
import ParentAadhaarCard from './IDProof/ParentAadhaarCard';
import ParentPANCard from './IDProof/ParentPANCard';
import ParentRationCard from './IDProof/ParentRationCard';
import ParentVoterCard from './IDProof/ParentVoterCard';
import ParentDrivingLicense from './IDProof/ParentDrivingLicense';
import ParentPassport from './IDProof/ParentPassport';
import ParentIncomeCertificate from './IncomeProof/IncomeCertificate';
import SchemeCard from './SchemeCard';
import Donors from './Donors';

function PatientParentDetails() {
  return (
    <Grid container direction='row' justifyContent='space-between' alignItems='stretch'>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentAadhaarCard />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentPANCard />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentRationCard />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentVoterCard />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentDrivingLicense />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentPassport />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <ParentIncomeCertificate />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <SchemeCard />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        lg={4}
        xl={4}
        sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0, lg: 2, xl: 2 } }}
      >
        <Donors />
      </Grid>
    </Grid>
  );
}

export default PatientParentDetails;
